import { clientPath, lpRequest } from '../../../../core/utils/lp-backend';
import { getUser } from './get-user';

/** `DELETE /client/:cid/users/:user_id/regions/:region_id`, then the user as cb returned it. */
export const revokeRegionAccess = async (user_id: string, region_id: string): Promise<any> => {
  await lpRequest('DELETE', clientPath(`/users/${user_id}/regions/${region_id}`));

  return getUser(user_id);
};
